import initialState from './initialState';
import {
  CLOSE_EMAIL_CHANNEL_CAPTURE,
  OPEN_WEB_PUSH_CHANNEL_CAPTURE,
  CLOSE_WEB_PUSH_CHANNEL_CAPTURE,
  OPEN_EMAIL_CHANNEL_CAPTURE,
} from './actionTypes';

export default (state = initialState, { type }) => {
  switch (type) {
    case OPEN_EMAIL_CHANNEL_CAPTURE:
      return { ...state, isEmailChannelCaptureOpen: true };

    case CLOSE_EMAIL_CHANNEL_CAPTURE:
      return { ...state, isEmailChannelCaptureOpen: false };

    case OPEN_WEB_PUSH_CHANNEL_CAPTURE:
      return { ...state, isWebPushChannelCaptureOpen: true };

    case CLOSE_WEB_PUSH_CHANNEL_CAPTURE:
      return {
        ...state,
        isWebPushChannelCaptureOpen: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/settings/reducer.js